(function () {
  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function getOverlay() {
    var overlay = document.getElementById('tcb-cart-drawer-overlay');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = 'tcb-cart-drawer-overlay';
    overlay.className = 'tcb-cart-drawer-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', function () {
      setCartOpen(false);
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function resetDrawerSizing(cart) {
    if (!cart) return;
    cart.style.setProperty('max-height', 'none', 'important');
    cart.style.setProperty('height', '100dvh', 'important');
    cart.style.setProperty('position', 'fixed', 'important');
    cart.style.setProperty('opacity', '1', 'important');
    cart.style.setProperty('visibility', 'visible', 'important');
    cart.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
    cart.style.setProperty('scale', '1', 'important');
    cart.style.setProperty('z-index', '1000', 'important');
    cart.style.setProperty('overflow', 'hidden', 'important');

    var inner = cart.querySelector('.tcb-cart-drawer__body, .mini-cart__inner');
    if (inner) {
      inner.style.setProperty('flex', '1 1 auto', 'important');
      inner.style.setProperty('min-height', '0', 'important');
      inner.style.setProperty('height', 'auto', 'important');
      inner.style.setProperty('max-height', 'none', 'important');
      inner.style.setProperty('overflow', 'hidden', 'important');
      inner.style.setProperty('justify-content', 'flex-start', 'important');
    }

    var scroll = cart.querySelector('.tcb-cart-drawer__scroll, .mini-cart__content');
    if (scroll) {
      scroll.style.removeProperty('max-height');
      scroll.style.setProperty('max-height', 'none', 'important');
      scroll.style.setProperty('overflow', 'hidden', 'important');
      scroll.style.setProperty('flex', '1 1 auto', 'important');
      scroll.style.setProperty('min-height', '0', 'important');
    }

    var list = cart.querySelector('[data-tcb-cart-line-list], .mini-cart__line-item-list');
    if (list) {
      list.style.setProperty('max-height', 'none', 'important');
      list.style.setProperty('overflow-y', 'auto', 'important');
      list.style.setProperty('overflow-x', 'hidden', 'important');
      list.style.setProperty('flex', '1 1 auto', 'important');
      list.style.setProperty('min-height', '0', 'important');
    }

    cart.querySelectorAll('.tcb-cart-drawer__recap, .mini-cart__recap, .tcb-cart-drawer__upsell').forEach(function (el) {
      el.style.setProperty('flex-shrink', '0', 'important');
    });
  }

  function enforceDrawerLayout(cart) {
    if (!cart || cart.getAttribute('aria-hidden') !== 'false') return;
    resetDrawerSizing(cart);
  }

  function clearDrawerInlineSizing(cart) {
    if (!cart) return;
    cart.style.removeProperty('max-height');
    cart.style.removeProperty('height');
    cart.style.removeProperty('scale');
    cart.style.removeProperty('transform');
    var content = cart.querySelector('.mini-cart__content');
    if (content) {
      content.style.removeProperty('max-height');
      content.style.removeProperty('overflow');
    }
    var list = cart.querySelector('.mini-cart__line-item-list');
    if (list) list.style.removeProperty('max-height');
  }

  function syncDrawerOpenState(cart) {
    if (!cart) return;
    var open = cart.getAttribute('aria-hidden') === 'false';
    var overlay = getOverlay();
    document.documentElement.classList.toggle('tcb-cart-drawer-open', open);
    document.documentElement.classList.toggle('is-locked', open);
    overlay.classList.toggle('is-visible', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      enforceDrawerLayout(cart);
      requestAnimationFrame(function () { enforceDrawerLayout(cart); });
      setTimeout(function () { enforceDrawerLayout(cart); }, 50);
      setTimeout(function () { enforceDrawerLayout(cart); }, 200);
    } else {
      clearDrawerInlineSizing(cart);
    }

    document.querySelectorAll('[data-tcb-scroll-top]').forEach(function (btn) {
      btn.hidden = open;
    });
  }

  function setCartOpen(open) {
    var cart = document.getElementById('mini-cart');
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (!cart) return;

    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var icon = toggle.querySelector('.header__cart-icon');
      if (icon) icon.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    syncDrawerOpenState(cart);

    if (open) {
      var focusTarget = cart.querySelector('.tcb-cart-drawer__close, [data-action="close-mini-cart"], .mini-cart__line-item-list a, .button');
      if (focusTarget) {
        setTimeout(function () { focusTarget.focus(); }, 60);
      }
    }
  }

  window.tcbSetCartOpen = setCartOpen;

  function portalCartToBody(cart) {
    if (!cart || cart.getAttribute('data-tcb-cart-portal') === '1') return;
    cart.setAttribute('data-tcb-cart-portal', '1');
    document.body.appendChild(cart);
  }

  function bindQuickAddForms(root) {
    if (!root) return;
    root.querySelectorAll('.tcb-fbt-add-form').forEach(function (form) {
      if (form.getAttribute('data-tcb-cart-bound') === '1') return;
      form.setAttribute('data-tcb-cart-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.tcb-fbt-add, .tcb-cart-fbt__add');
        var resetLabel = btn ? btn.textContent : 'Add';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding…';
        }
        fetch(cartRoute('/cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (res) {
            if (!res.ok) {
              if (btn) {
                btn.textContent = 'Unavailable';
                setTimeout(function () {
                  btn.disabled = false;
                  btn.textContent = resetLabel;
                }, 1800);
              }
              return;
            }
            if (btn) {
              btn.textContent = 'Added ✓';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = resetLabel;
              }, 1600);
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { scrollToTop: false }
            }));
            document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
            fetch(cartRoute('/cart.js'), { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cartData) {
                if (!cartData || typeof cartData.item_count !== 'number') return;
                document.querySelectorAll('.header__cart-count, [data-tcb-cart-count]').forEach(function (el) {
                  el.textContent = cartData.item_count;
                  if (el.hasAttribute('data-tcb-cart-count')) el.hidden = cartData.item_count === 0;
                });
              })
              .catch(function () {});
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  function initCartFbtCarousel(root) {
    var wraps = root.querySelectorAll ? root.querySelectorAll('[data-tcb-cart-fbt]') : [];
    if (root.matches && root.matches('[data-tcb-cart-fbt]')) {
      wraps = [root];
    }
    wraps.forEach(function (wrap) {
      if (wrap.getAttribute('data-bound') === '1') return;
      wrap.setAttribute('data-bound', '1');

      var track = wrap.querySelector('[data-tcb-cart-fbt-track]');
      var prevButtons = wrap.querySelectorAll('[data-tcb-cart-fbt-prev]');
      var nextButtons = wrap.querySelectorAll('[data-tcb-cart-fbt-next]');
      if (!track) return;

      var prev = prevButtons[0];
      var next = nextButtons[0];

      function step(dir) {
        var card = track.querySelector('.tcb-cart-fbt__card');
        var amount = card ? card.offsetWidth + 10 : 240;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      function updateArrows() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prevButtons.forEach(function (btn) { btn.disabled = track.scrollLeft <= 2; });
        nextButtons.forEach(function (btn) { btn.disabled = track.scrollLeft >= max; });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      prevButtons.forEach(function (btn) {
        if (btn !== prev) btn.addEventListener('click', function () { step(-1); });
      });
      nextButtons.forEach(function (btn) {
        if (btn !== next) btn.addEventListener('click', function () { step(1); });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }

  function initCartUpsells(root) {
    if (!root) return;
    bindQuickAddForms(root);
    initCartFbtCarousel(root);
  }

  window.TcbCartDrawerInitUpsells = initCartUpsells;

  function bindCartToggle() {
    if (document.documentElement.getAttribute('data-tcb-cart-toggle-bound') === '1') return;
    document.documentElement.setAttribute('data-tcb-cart-toggle-bound', '1');

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-action="toggle-mini-cart"], .header__cart-toggle[aria-controls="mini-cart"]');
      if (!toggle) return;
      if (window.theme && window.theme.cartType === 'page') return;
      if (!document.getElementById('mini-cart')) return;
      e.preventDefault();
      e.stopPropagation();
      var cart = document.getElementById('mini-cart');
      setCartOpen(cart.getAttribute('aria-hidden') === 'true');
    }, true);
  }

  function wireCartNode(cart) {
    if (!cart) return;
    cart.classList.add('tcb-cart-drawer');
    portalCartToBody(cart);
    initCartUpsells(cart);
    syncDrawerOpenState(cart);
  }

  function initCartDrawer() {
    var cart = document.getElementById('mini-cart');
    if (!cart || cart.getAttribute('data-tcb-drawer-init') === '1') return;
    cart.setAttribute('data-tcb-drawer-init', '1');
    getOverlay();
    bindCartToggle();
    wireCartNode(cart);

    var observer = new MutationObserver(function () {
      syncDrawerOpenState(cart);
    });
    observer.observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });

    var styleObserver = new MutationObserver(function () {
      if (cart.getAttribute('aria-hidden') === 'false') enforceDrawerLayout(cart);
    });
    styleObserver.observe(cart, { attributes: true, attributeFilter: ['style'] });

    var content = cart.querySelector('.mini-cart__content');
    if (content) {
      var contentStyleObserver = new MutationObserver(function () {
        if (cart.getAttribute('aria-hidden') === 'false') {
          content.style.setProperty('max-height', 'none', 'important');
        }
      });
      contentStyleObserver.observe(content, { attributes: true, attributeFilter: ['style'] });
    }

    document.documentElement.addEventListener('product:added', function () {
      if (window.theme && window.theme.pageType !== 'cart' && window.theme.cartType === 'drawer') {
        setCartOpen(true);
      }
    });

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-action="close-mini-cart"]');
      if (!closeBtn) return;
      e.preventDefault();
      setCartOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!document.documentElement.classList.contains('tcb-cart-drawer-open')) return;
      if (e.target.closest('#mini-cart, [data-action="toggle-mini-cart"], .header__cart-toggle')) return;
      setCartOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cart.getAttribute('aria-hidden') === 'false') {
        setCartOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (cart.getAttribute('aria-hidden') === 'false') {
        enforceDrawerLayout(cart);
      }
    });

    document.addEventListener('cart:rerendered', function () {
      var fresh = document.getElementById('mini-cart');
      if (!fresh) return;
      fresh.classList.add('tcb-cart-drawer');
      portalCartToBody(fresh);
      fresh.querySelectorAll('[data-tcb-cart-fbt]').forEach(function (el) {
        el.removeAttribute('data-bound');
      });
      initCartUpsells(fresh);
      syncDrawerOpenState(fresh);
      if (fresh.getAttribute('aria-hidden') === 'false') {
        enforceDrawerLayout(fresh);
      }
    });

    var cartPage = document.querySelector('.shopify-section--tcb-cart-page, [data-section-type="cart"]');
    if (cartPage) initCartUpsells(cartPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
